export default __webpack_public_path__ + "static/Karel Pramadiputra Sanusi-e76aa4c398ad0202d38b060c6483969c.webp";